export function formatPrice(
  amount: number,
  currency: string,
  options?: {
    locale?: string;
    digits?: number;
  },
) {
  const { locale = "en-US", digits = 2 } = options ?? {};
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: digits,
  }).format(amount);
}
